import type { ReactNode } from "react";
import { Card, CardContent } from "@runcheetah/ui";

import { cn } from "@/lib/utils";

export interface MetricTileProps {
  label: ReactNode;
  value: ReactNode;
  icon?: ReactNode;
  className?: string;
  valueClassName?: string;
}

export function MetricTile({ label, value, icon, className, valueClassName }: MetricTileProps) {
  return (
    <Card className={cn("border-border/70 bg-card/80", className)}>
      <CardContent className="flex items-center justify-between gap-3 p-4">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            {label}
          </div>
          <div className={cn("mt-2 text-2xl font-semibold tabular-nums", valueClassName)}>
            {value}
          </div>
        </div>
        {icon ? <div className="shrink-0">{icon}</div> : null}
      </CardContent>
    </Card>
  );
}
